import React, { useState, useEffect } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../BaseUrl";

//functions
import { getCookie } from "../functions/Functions";

// creating context api
const FinanceContext = React.createContext();

const INITIAL_SAVE_DATA = [
  { name: "cash_account_id", value: "" },
  { name: "withholding_tax_account_id", value: "" },
  { name: "other_tax_account_id", value: "" },
  { name: "bank_account_id", value: "" },
  { name: "inventory_account_id", value: "" },
  { name: "revenue_account_id", value: "" },
  { name: "cogs_id", value: "" },
  { name: "purchase_discount_id", value: "" },
  { name: "sales_discount_id", value: "" },
  { name: "purchase_tax_id", value: "" },
  { name: "sales_tax_id", value: "" },
  { name: "supplier_cash_account_id", value: "" },
  { name: "supplier_payable_account_id", value: "" },
  { name: "suspense_account_id", value: "" },
  { name: "delivery_charges_account_id", value: "" },
  { name: "service_charges_account_id", value: "" },
  { name: "finished_goods_account_id", value: "" },
  { name: "additional_cost_account_id", value: "" },
  { name: "grir_account_id", value: "" },
  { name: "f_inventory_account_id", value: "" },
  { name: "f_revenue_account_id", value: "" },
  { name: "f_cogs_id", value: "" },
  { name: "customer_account_id", value: "" },
  { name: "transportation_account_id", value: "" },
  { name: "advance_tax_id", value: "" },
  { name: "stock_adjustment_account_id", value: "" },
];

const INITIAL_ACCOUNTS_STATE = {
  cashAcc: [],
  whtAcc: "",
  otherTaxAcc: "",
  bankAcc: [],
  invAcc: "",
  revAcc: "",
  cogs: "",
  purchaseDis: "",
  salesDis: "",
  purchaseTax: "",
  salesTax: "",
  suppCashAcc: "",
  suspenseAcc: "",
  suppPayableAcc: "",
  deliveryAcc: "",
  serviceChargesAcc: "",
  finishedGoodsAcc: "",
  additionalCostAcc: "",
  grirAccount: "",
  fInvAcc: "",
  fRevAcc: "",
  fCogs: "",
  customerAccount: "",
  transportationAccount: "",
  advanceTaxAcc: "",
  stockAdjustmentAccount: "",
};

const FINANCE_SETTING_MAPPING = {
  cash_account_id: { key: "cashAcc", index: 0, multi: true },
  withholding_tax_account_id: { key: "whtAcc", index: 1 },
  other_tax_account_id: { key: "otherTaxAcc", index: 2 },
  bank_account_id: { key: "bankAcc", index: 3, multi: true },
  inventory_account_id: { key: "invAcc", index: 4 },
  revenue_account_id: { key: "revAcc", index: 5 },
  cogs_id: { key: "cogs", index: 6 },
  purchase_discount_id: { key: "purchaseDis", index: 7 },
  sales_discount_id: { key: "salesDis", index: 8 },
  purchase_tax_id: { key: "purchaseTax", index: 9 },
  sales_tax_id: { key: "salesTax", index: 10 },
  supplier_cash_account_id: { key: "suppCashAcc", index: 11 },
  supplier_payable_account_id: { key: "suppPayableAcc", index: 12 },
  suspense_account_id: { key: "suspenseAcc", index: 13 },
  delivery_charges_account_id: { key: "deliveryAcc", index: 14 },
  service_charges_account_id: { key: "serviceChargesAcc", index: 15 },
  finished_goods_account_id: { key: "finishedGoodsAcc", index: 16 },
  additional_cost_account_id: { key: "additionalCostAcc", index: 17 },
  grir_account_id: { key: "grirAccount", index: 18 },
  f_inventory_account_id: { key: "fInvAcc", index: 19, multi: true },
  f_revenue_account_id: { key: "fRevAcc", index: 20, multi: true },
  f_cogs_id: { key: "fCogs", index: 21, multi: true },
  customer_account_id: { key: "customerAccount", index: 22 },
  transportation_account_id: { key: "transportationAccount", index: 23 },
  advance_tax_id: { key: "advanceTaxAcc", index: 24 },
  stock_adjustment_account_id: { key: "stockAdjustmentAccount", index: 25 },
};

const FinanceProvider = ({ children }) => {
  // State hooks  here
  //loading
  const [loading, setLoading] = useState(false);
  const [dataPaginating, setDataPaginating] = useState(false);

  // localStorage helper
  const setDataToLocal = (url, res) => {
    localStorage.setItem(url, JSON.stringify(res));
  };

  // localStorage helper
  const getDataFromLocal = (url) => {
    return JSON.parse(localStorage.getItem(url));
  };

  //check if offline helper
  const offline = (url) => {
    return localStorage.getItem(url) != null;
  };

  // Generic helper to handle API response and update states
  const handleListResponse = (res, setters, isPagination = false) => {
    const { main, search, active, custom } = setters;
    if (custom) {
      custom(res.data);
    } else {
      if (main) main(res.data[0]);
      if (search) search(res.data[1]);
      if (active && res.data[2] !== undefined) active(res.data[2]);
    }

    if (isPagination) {
      setDataPaginating(false);
    } else {
      setLoading(false);
    }
  };

  // Generic fetcher for lists
  const fetchListData = async (endpoint, setters, isPagination = false, pageNo = null) => {
    const statusSetter = isPagination ? setDataPaginating : setLoading;
    statusSetter(true);

    const url = isPagination ? `${BASE_URL}${endpoint}?page=${pageNo}` : `${BASE_URL}${endpoint}`;

    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      handleListResponse(res, setters, isPagination);
    } catch (error) {
      statusSetter(false);
      console.error(`Error fetching from ${endpoint}:`, error);
    }
  };

  //useEffect- to get data on render
  useEffect(() => {
    //call- unauthenticated
    // getFoodWeb();
    //call if authenticated
    if (getCookie() !== undefined && window.location.pathname !== "/dashboard/accounts/gl-setting" && (window.location.pathname.includes("dashboard/account"))) {
      getCoaL1();
      getCoaL2();
    }
    if(getCookie() !== undefined && ((window.location.pathname !== "/dashboard/accounts/gl-setting" && (window.location.pathname.includes("dashboard/account"))) || (window.location.pathname.includes("dashboard/manage/food/department")))){
      getCoaL3();
    }
  }, []);

  //Coa1 list
  const [coa1, setCoa1] = useState(null);
  const [coa1ForSearch, setCoa1ForSearch] = useState(null);
  const [cao1Active, setCoa1Active] = useState(null);
  // States hook here
  const [saveData, setSaveData] = useState(INITIAL_SAVE_DATA);

  const [accounts, setAccounts] = useState(INITIAL_ACCOUNTS_STATE);

  const getModuleSetting = async (coa3ForSearchSettings, branch) => {
    setLoading(true);
    const moduleUrl = `${BASE_URL}/settings/get-module-setting/${branch.id}`;
    try {
      const res = await axios.get(moduleUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      const updatedSaveData = JSON.parse(JSON.stringify(INITIAL_SAVE_DATA));
      const updatedAccounts = { ...INITIAL_ACCOUNTS_STATE };

      if (res.data && Array.isArray(res.data)) {
        res.data.forEach((acc) => {
          const config = FINANCE_SETTING_MAPPING[acc.field];
          if (config) {
            const { key, index, multi } = config;
            if (multi) {
              const ids = JSON.parse(acc.value || "[]");
              updatedAccounts[key] = ids.map((id) => coa3ForSearchSettings[id] || "");
              updatedSaveData[index].value = ids.length === 0 ? "" : ids;
            } else {
              const mappedValue = coa3ForSearchSettings[acc.value] || "";
              updatedAccounts[key] = mappedValue;
              updatedSaveData[index].value = mappedValue === "" ? "" : acc.value;
            }
          }
        });
      }
      setSaveData(updatedSaveData);
      setAccounts(updatedAccounts);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error==>", error);
    }
  };

  //get Coa level 1
  const getCoaL1 = () => fetchListData("/settings/get-coa-level1", { main: setCoa1, search: setCoa1ForSearch, active: setCoa1Active });

  //get paginated coa1
  const setPaginatedCoa1 = (pageNo) => fetchListData("/settings/get-coa-level1", { main: setCoa1, search: setCoa1ForSearch, active: setCoa1Active }, true, pageNo);

  //Coa2 list
  const [coa2, setCoa2] = useState(null);
  const [coa2ForSearch, setCoa2ForSearch] = useState(null);
  const [cao2Active, setCoa2Active] = useState(null);

  //get Coa level 2
  const getCoaL2 = () => fetchListData("/settings/get-coa-level2", { main: setCoa2, search: setCoa2ForSearch, active: setCoa2Active });

  //get paginated coa2
  const setPaginatedCoa2 = (pageNo) => fetchListData("/settings/get-coa-level2", { main: setCoa2, search: setCoa2ForSearch, active: setCoa2Active }, true, pageNo);

  //Coa3 list
  const [coa3, setCoa3] = useState(null);
  const [coa3ForSearch, setCoa3ForSearch] = useState(null);
  const [cao3Active, setCoa3Active] = useState(null);
  const [coa3ForSearchById, setCoa3ForSearchById] = useState(null);
  const [invRevAcc, setInvRevAcc] = useState(null);

  //get inv, rev, coa acc
  const getInvRevAcc = async (branch_id = 1) => {
    setLoading(true);
    const url = BASE_URL + `/settings/foodsInn/get-foodsinn-accounts/${branch_id}`;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setInvRevAcc(res.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleCoaL3Response = (data) => {
    setCoa3(data[0]);
    setCoa3ForSearch(data[1]);
    const obj = {};
    if(data[1]){
      data[1].forEach((item) => {
        obj[parseInt(item.id)] = item;
      });
    }
    setCoa3ForSearchById(obj);
    if (data[2] !== undefined) setCoa3Active(data[2]);
  };

  //get Coa level 3
  const getCoaL3 = () => fetchListData("/settings/get-coa-level3", { custom: handleCoaL3Response });

  //get paginated coa3
  const setPaginatedCoa3 = (pageNo) => fetchListData("/settings/get-coa-level3", { custom: handleCoaL3Response }, true, pageNo);

  //Bank payment list
  const [bankPaymentList, setBankPaymentList] = useState(null);
  const [bankPaymentListForSearch, setBankPaymentListForSearch] = useState(null);

  //get bank payment list
  const getBPList = () => fetchListData("/settings/get-bank-payment", { main: setBankPaymentList, search: setBankPaymentListForSearch });

  //get paginated BPList
  const setPaginatedBPList = (pageNo) => fetchListData("/settings/get-bank-payment", { main: setBankPaymentList, search: setBankPaymentListForSearch }, true, pageNo);

  //Cash payment list
  const [cashPaymentList, setCashPaymentList] = useState(null);
  const [cashPaymentListForSearch, setCashPaymentListForSearch] = useState(null);

  //get cash payment list
  const getCPList = () => fetchListData("/settings/get-cash-payment", { main: setCashPaymentList, search: setCashPaymentListForSearch });

  //get paginated CPList
  const setPaginatedCPList = (pageNo) => fetchListData("/settings/get-cash-payment", { main: setCashPaymentList, search: setCashPaymentListForSearch }, true, pageNo);

  //Journal voucher list
  const [journalVoucherList, setJournalVoucherList] = useState(null);
  const [journalVoucherListForSearch, setJournalVoucherListForSearch] = useState(null);

  //get journal voucher list
  const getJVList = () => fetchListData("/settings/get-journal-voucher", { main: setJournalVoucherList, search: setJournalVoucherListForSearch });

  //get paginated JVList
  const setPaginatedJVList = (pageNo) => fetchListData("/settings/get-journal-voucher", { main: setJournalVoucherList, search: setJournalVoucherListForSearch }, true, pageNo);

  //Opening account list
  const [openingAccountList, setOpeningAccountList] = useState(null);
  const [openingAccountListForSearch, setOpeningAccountListForSearch] = useState(null);

  //get opening account list
  const getOAList = () => fetchListData("/settings/get-opening-account", { main: setOpeningAccountList, search: setOpeningAccountListForSearch });

  //get paginated OAList
  const setPaginatedOAList = (pageNo) => fetchListData("/settings/get-opening-account", { main: setOpeningAccountList, search: setOpeningAccountListForSearch }, true, pageNo);

  return (
    <FinanceContext.Provider
      value={{
        // common
        loading,
        setLoading,

        //coa1
        coa1,
        setCoa1,
        coa1ForSearch,
        setCoa1ForSearch,
        cao1Active,
        getCoaL1,
        setPaginatedCoa1,

        //coa2
        coa2,
        setCoa2,
        coa2ForSearch,
        cao2Active,
        setCoa2ForSearch,
        getCoaL2,
        setPaginatedCoa2,

        //coa3
        coa3, 
        setCoa3,
        coa3ForSearch,
        cao3Active,
        setCoa3ForSearch,
        coa3ForSearchById,
        getCoaL3,
        setPaginatedCoa3,
        getModuleSetting,

        //BPList
        bankPaymentList,
        setBankPaymentList,
        bankPaymentListForSearch,
        setBankPaymentListForSearch,
        getBPList,
        setPaginatedBPList,

        //CPList
        cashPaymentList,
        setCashPaymentList,
        cashPaymentListForSearch,
        setCashPaymentListForSearch,
        getCPList,
        setPaginatedCPList,

        //JVList
        journalVoucherList,
        setJournalVoucherList,
        journalVoucherListForSearch,
        setJournalVoucherListForSearch,
        getJVList,
        setPaginatedJVList,

        //OAList
        openingAccountList,
        setOpeningAccountList,
        openingAccountListForSearch,
        setOpeningAccountListForSearch,
        getOAList,
        setPaginatedOAList,

        //transaction account
        // bankAccounts,
        // setBankAccounts,

        //pagination
        dataPaginating,
        setDataPaginating,

        // account module
        saveData,
        setSaveData,
        accounts,
        setAccounts,
      }}
    >
      {children}
    </FinanceContext.Provider>
  );
};

export { FinanceContext, FinanceProvider };
